import React from "react";

import { CreateNFeContext } from "../../Context";

import ShippingValue from "./ShippingValue";
import NFeTransporter from "./NFeTransporter";
import NFeVolumes from "./NFeVolumes";

export default () => <CreateNFeContext.Consumer>
    {
        context => {
            const { mod_frete } = context["nfe"]["transport"]
            const { setNFeTransportShipping } = context["handlers"]

            return <div className="row">
                <div className="col-12">
                    <p className="lead mb-1">Frete</p>
                </div>
                <div className={mod_frete === "9" ? "col-md-12" : "col-md-6 py-2"}>
                    <div>
                        Modalidade do Frete
                    </div>
                    <select
                        data-cy-test="#nfe-issuer-select-transport-type"
                        onChange={setNFeTransportShipping}
                        className="form-control">
                        <option selected={mod_frete === "0"} value="0">
                            0= Contratação do Frete por conta do Remetente (CIF)
                        </option>
                        <option selected={mod_frete === "1"} value="1">
                            1= Contratação do Frete por conta do Destinatário (FOB)
                        </option>
                        <option selected={mod_frete === "2"} value="2">
                            2= Contratação do Frete por conta de Terceiros
                        </option>
                        <option selected={mod_frete === "3"} value="3">
                            3= Transporte Próprio por conta do Remetente
                        </option>
                        <option selected={mod_frete === "4"} value="4">
                            4= Transporte Próprio por conta do Destinatário
                        </option>
                        <option selected={mod_frete === "9"} value="9">
                            9= Sem Ocorrência de Transporte
                        </option>
                    </select>
                </div>
                <div className="col-md-6">
                    <ShippingValue />
                </div>
                <div className={mod_frete !== "9" ? "py-2 col-12" : "d-none"}>
                    <p className="lead mb-0">
                        Volumes
                    </p>
                    <NFeVolumes />
                </div>
                <div className={mod_frete !== "9" ? "col-12" : "d-none"}>
                    <p className="lead mb-0">
                        Transportadora
                    </p>
                    <NFeTransporter />
                </div>
            </div>
        }
    }
</CreateNFeContext.Consumer>


// WEBPACK FOOTER //
// ./src/views/Fiscal/NFe/Issuer/NFePaymentShipping/ShippingTransporter/index.jsx